import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardLayoutComponent } from './dashboard-layout.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { NavsearchComponent } from './header/navsearch/navsearch.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
  ],
  declarations: [
    DashboardLayoutComponent,
    FooterComponent,
    HeaderComponent,
    NavsearchComponent,
    SidebarComponent,
  ],
  exports: [
    DashboardLayoutComponent,
  ],
})
export class DashboardLayoutModule {}



// WEBPACK FOOTER //
// ./src/app/layouts/dashboard/dashboard-layout.module.ts